import type { SeriesStatus } from '@vmt/shared';
import clsx from 'clsx';
import type { ReactNode } from 'react';
import { STATUS_LABEL } from '../../lib/format';

type Tone = 'neutral' | 'accent' | 'success' | 'warning' | 'danger' | 'team-a' | 'team-b';

const tones: Record<Tone, string> = {
  neutral: 'bg-ink-700 text-ink-300',
  accent: 'bg-accent-muted text-accent',
  success: 'bg-success/15 text-success',
  warning: 'bg-warning/15 text-warning',
  danger: 'bg-danger/15 text-danger',
  'team-a': 'bg-team-a-muted text-team-a',
  'team-b': 'bg-team-b-muted text-team-b',
};

export function Badge({
  tone = 'neutral',
  children,
  className,
}: {
  tone?: Tone;
  children: ReactNode;
  className?: string;
}) {
  return (
    <span
      className={clsx(
        'inline-flex items-center gap-1 px-2 py-0.5 font-display text-xs font-bold tracking-wider whitespace-nowrap uppercase',
        tones[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}

const statusTone: Record<SeriesStatus, Tone> = {
  draft: 'neutral',
  veto: 'warning',
  live: 'accent',
  finished: 'success',
  cancelled: 'danger',
};

export function StatusBadge({ status }: { status: SeriesStatus }) {
  return (
    <Badge tone={statusTone[status]}>
      {(status === 'live' || status === 'veto') && (
        <span className="size-1.5 animate-pulse rounded-full bg-current" />
      )}
      {STATUS_LABEL[status]}
    </Badge>
  );
}
